import React from 'react';

import ContentContainer from 'components-layout/ContentContainer';

function PrivacyPolicy() {
  return (
    <ContentContainer>
      <h2>Privacy Policy</h2>

      <p>
        THE WEBSITE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
      </p>

      <p>
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        WEBSITE OR THE USE OR OTHER DEALINGS IN THE WEBSITE.
      </p>

      <p>
        ALL SESSION DATA IS KEPT PRIVATE AND PERSONAL INFORMATION IS
        CONFIDENTIAL.
      </p>
    </ContentContainer>
  );
}

export default PrivacyPolicy;
